<template>
  <RevDrawer :name="MODAL_NAMES.PAYPAY" :title="i18n(translations.title)">
    <template #body>
      <div class="mb-24 text-center">
        <RevIllustration
          alt=""
          class="rounded-md w-full"
          :height="240"
          src="/img/product/jp/paypay-illustration.png"
          :width="327"
        />
      </div>

      <h2 class="heading-2 mb-16">
        {{ i18n(translations.subtitle, { points }) }}
      </h2>
      <p class="body-1 mb-24">
        {{ i18n(translations.description) }}
      </p>
      <p class="body-1 mb-16">
        {{ i18n(translations.list) }}
      </p>
      <ul class="body-1 flex flex-col gap-12">
        <li class="flex items-center gap-12">
          <div
            class="bg-static-default-mid rounded-full body-1-bold size-32 shrink-0 text-center leading-[32px]"
          >
            1
          </div>
          {{ i18n(translations.item1) }}
        </li>
        <li class="flex items-center gap-12">
          <div
            class="bg-static-default-mid rounded-full body-1-bold size-32 shrink-0 text-center leading-[32px]"
          >
            2
          </div>
          {{ i18n(translations.item2) }}
        </li>
        <li class="flex items-center gap-12">
          <div
            class="bg-static-default-mid rounded-full body-1-bold size-32 shrink-0 text-center leading-[32px]"
          >
            3
          </div>
          {{ i18n(translations.item3) }}
        </li>
      </ul>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'
import { RevIllustration } from '@ds/components/Illustration'

import { MODAL_NAMES } from '../../Product-JP.constants'

import translations from './PaypayModal.translations'

defineProps<{ points: string }>()

const i18n = useI18n()
</script>
